import { G } from "../constants/theme";

export function ageColor(days) {
  if (days == null || days < 14) return { bg: G.gray100, c: G.gray600 };
  if (days < 30) return { bg: G.amber100, c: G.amber700 };
  return { bg: G.red100, c: G.red700 };
}

export function statusCol(status = "") {
  const s = status.toLowerCase();
  if (s === "done" || s === "closed" || s === "resolved") {
    return { bar: G.green600, bg: G.green50, c: G.green700 };
  }
  if (s === "in progress" || s === "in review") {
    return { bar: G.blue600, bg: G.blue50, c: G.blue700 };
  }
  if (s === "blocked") {
    return { bar: G.red600, bg: G.red50, c: G.red700 };
  }
  return { bar: G.gray400, bg: G.gray100, c: G.gray600 };
}

export function priorityCol(priority = "") {
  switch (priority) {
    case "Critical":  return { bg: "#FEE2E2", c: "#B91C1C" };
    case "Highest":   return { bg: "#FEE2E2", c: "#DC2626" };
    case "High":      return { bg: "#FEF3C7", c: "#B45309" };
    case "Medium":    return { bg: "#EFF6FF", c: "#1D4ED8" };
    case "Low":       return { bg: G.gray100, c: G.gray600 };
    case "Lowest":    return { bg: G.gray100, c: G.gray500 };
    default:          return { bg: G.gray100, c: G.gray500 };
  }
}

// One themed chip treatment for priority / severity markers and score-breakdown
// rows. Deliberately monochrome — brand blue on light panels, sky blue on the
// dark (#071A2F) sections — so the UI stays uniform and on-theme rather than
// colourful. Returns null only for an empty label.
export function priorityTone(label = "") {
  if (!String(label).trim()) return null;
  return {
    dot: G.brand,                       // #2563EB
    bg: G.blue100,                      // #DBEAFE
    c: G.blue700,                       // #1D4ED8
    border: G.brandBorder,              // #BFDBFE
    darkC: "#93C5FD",                   // on-navy accent used across the app
    darkBg: "rgba(37,99,235,0.22)",     // brand tint, matches Sidebar/Dashboard
    darkBorder: "rgba(147,197,253,0.35)",
  };
}

const SIGNAL_COLORS = {
  CRITICAL:  "#DC2626",
  AGEING:    "#D97706",
  STALLED:   "#7C3AED",
  IDLE:      "#6B7280",
  UNOWNED:   "#DB2777",
  "QUICK WIN": "#16A34A",
};
const SIGNAL_BG = {
  CRITICAL:  "#FEE2E2",
  AGEING:    "#FEF3C7",
  STALLED:   "#EDE9FE",
  IDLE:      "#F3F4F6",
  UNOWNED:   "#FCE7F3",
  "QUICK WIN": "#DCFCE7",
};

export function signalToColor(signal = "") {
  return SIGNAL_COLORS[signal.toUpperCase()] || G.gray500;
}

export function signalToBg(signal = "") {
  return SIGNAL_BG[signal.toUpperCase()] || G.gray100;
}

export function healthColor(health) {
  switch (health) {
    case "healthy":   return { dot: G.green500, label: "Healthy",   text: G.green500 };
    case "attention": return { dot: G.amber600, label: "Attention", text: G.amber600 };
    case "at-risk":   return { dot: "#F97316", label: "At Risk",    text: "#F97316" };
    case "critical":  return { dot: G.red600,   label: "Critical",  text: G.red600 };
    default:          return { dot: G.gray400,  label: "Unknown",   text: G.gray400 };
  }
}
